import { createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';

import { isDev } from '../constants/api';
import reducers from '../reducers';
import { persistConfig } from './config';

export function getStore() {
  const middlewares = [thunk];

  let composeEnhancer = compose;

  if (isDev) {
    middlewares.push(
      createLogger({
        diff: true,
        collapsed: (getState, action, logEntry) => !logEntry.error,
      }),
    );
  }

  const persistedReducer = persistReducer(persistConfig, reducers);
  const store = createStore(
    persistedReducer,
    composeEnhancer(applyMiddleware(...middlewares)),
  );
  const persistor = persistStore(store);

  return { store, persistor };
}
